<template>
    <TabsCard
        v-loading="loading"
        v-if="count"
        class="tabs-card"
        :count="count"
        cardTitle="Проекты"
        :isDataFull="lastProject.isDataFull"
        :infoTitle="lastProject.name"
        :imgLink="lastProject.image_link"
        :emptyImgLink="emptyImgLink"
        :selectBtnLink="selectBtnLink"
        emptyText="Нет активных проектов"
        :infoDescription="lastProject.description"
        :cardRouter="lastProject.cardRouter"
        :lmsLink="lastProject.lmsLink"
        toFullRouter="/account/projects"
        toFullBtnText="Смотреть все проекты"
        continueBtnText="Продолжить участие"
    />
    <EmptyTabsCard
        v-loading="loading"
        v-else
        :emptyImgLink="emptyImgLink"
        cardTitle="Проекты"
        toFullRouter="/competitions"
        emptyText="Нет активных проектов"
    />
</template>

<script>
import TabsCard from '../../../UI/TabsCard.vue';
import { mapGetters, mapActions } from 'vuex';
import EmptyTabsCard from '@/components/UI/EmptyTabsCard.vue';

export default {
    components: {
        EmptyTabsCard,
        TabsCard,
    },
    methods: {
        ...mapActions('accountTrack', [
            'loadAccountProjects',
            'loadAccountProjectsSPK2',
            'loadAllAccountProjects',
            'loadAllAccountProjectsSPK2',
        ]),
    },
    computed: {
        ...mapGetters('accountTrack', [
            'getLastAccountProject',
            'getLastAccountProjectSPK2',
            'getLastAccountProjectCount',
            'getLastAccountProjectSPK2Count',
        ]),

        emptyImgLink() {
            return require(`../../../../assets/images/oops-rhino.svg`);
        },
        rsvDomain() {
            return window.rsvDomain || 'rsv.ru';
        },

        lastProject() {
            if (this.getLastAccountProjectSPK2) {
                const project = this.getLastAccountProjectSPK2;

                return {
                    name: project.name,
                    image_link: project.logo,
                    description: project.greeting,
                    lmsLink: `https://project.${this.rsvDomain}/${
                        project.alias || project.id
                    }`,
                    isDataFull: true,
                };
            } else if (this.getLastAccountProject) {
                const project = this.getLastAccountProject;

                return {
                    name: project.name,
                    image_link: project.image_link,
                    description: project.description,
                    cardRouter: `/competition-system/${project.project_id}`,
                    isDataFull: true,
                };
            }

            return {
                isDataFull: false,
            };
        },

        count() {
            if (
                this.getLastAccountProjectCount === null ||
                this.getLastAccountProjectSPK2Count === null
            ) {
                return null;
            }

            return (
                this.getLastAccountProjectCount +
                this.getLastAccountProjectSPK2Count
            );
        },
    },
    data() {
        return {
            selectBtnLink: '/competitions',
            loading: true,
        };
    },
    async mounted() {
        await Promise.all([
            this.loadAccountProjects(),
            this.loadAccountProjectsSPK2(),
            this.loadAllAccountProjects(),
            this.loadAllAccountProjectsSPK2(),
        ]);
        this.loading = false;
    },
};
</script>

<style scoped lang="scss">
@import '~@/styles/rem';
.tabs-card {
    margin-bottom: mrem(23);

    @include on-desktop {
        margin-bottom: rem(30);
    }
}
</style>
